import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import UserRoutes from "../UserRoutes";
import PublicRoutes from "../PublicRoutes";
import AppLayout from "../../Components/AppLayout";
import { logout } from "../../utils/logout";
import { registerLogoutHandler } from "../../utils/authHandler";

const AppRoutes = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });

  useEffect(() => {
    registerLogoutHandler(() => logout(navigate, setUser));
  }, [user]);

  let routesComponent;

  switch (user?.role) {
    case "user":
      routesComponent = (
        <AppLayout setUser={setUser} user={user}>
          {<UserRoutes />}
        </AppLayout>
      );
      break;

    case "public":
      routesComponent = <PublicRoutes setUser={setUser} />;
      break;

    default:
      routesComponent = <PublicRoutes setUser={setUser} />;
      break;
  }

  return routesComponent;
};

export default AppRoutes;
